import { api, lockerSetup } from "../utils/constants";
import { throwError } from "./error";

const getHeaders = (props) => {
  return {
    Accept: "application/json",

    ...(props.removeContentType ? {} : { "Content-Type": "application/json" }),
    ...(props.fireBaseAccessToken
      ? { "x-auth-token": `Bearer ${props.fireBaseAccessToken}` }
      : {}),
    ...(props.abdmAccessToken
      ? { "x-abdm-token": `Bearer ${props.abdmAccessToken}` }
      : {}),
    ...(props.abhaAccessToken
      ? { "x-abha-token": `Bearer ${props.abhaAccessToken}` }
      : {}),
    ...(props.profileId ? { profileId: props.profileId } : {})
  };
};

export async function acceptConnection(inviteCode, fireBaseAccessToken) {
  const response = await fetch(`${api.baseUrl}/acceptConnectionRequest/`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-auth-token": `Bearer ${fireBaseAccessToken}`
    },
    body: JSON.stringify({
      requestId: inviteCode
    })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function getUserInformationFromGoogleApis() {
  return fetch(
    "https://www.googleapis.com/oauth2/v2/userinfo?access_token=YOUR_ACCESS_TOKEN"
  );
}

export async function sendOAuthAccessCode(
  fireBaseAccessToken,
  patientProfileId,
  accessCode = false
) {
  return await fetch(`${api.baseUrl}/getGoogleFitnessData`, {
    method: "POST",
    headers: getHeaders({
      fireBaseAccessToken
    }),
    body: JSON.stringify({
      ...(accessCode ? { accessCode } : {}),
      pid: patientProfileId
    })
  });
}

export async function checkHealthIdExists(
  fireBaseAccessToken,
  profileId,
  healthId
) {
  const response = await fetch(
    `${api.baseUrl}/profile/healthIdExists?healthId=${healthId}`,
    {
      method: "GET",
      headers: getHeaders({
        fireBaseAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function sendOtp(
  profileId,
  phoneNumber,
  userName,
  requestType,
  fireBaseAccessToken
) {
  const response = await fetch(
    `${
      api.baseUrl
    }/sendOtp?userType=patient-demographic&userPhoneNumber=${encodeURIComponent(
      phoneNumber
    )}&profileId=${profileId}&userFullName=${userName}&otpType=${requestType}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": `Bearer ${fireBaseAccessToken}`
      }
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function verifyOtp(
  profileId,
  phoneNumber,
  requestType,
  otp,
  fireBaseAccessToken
) {
  const response = await fetch(
    `${
      api.baseUrl
    }/validateOtp?userType=patient-demographic&userPhoneNumber=${encodeURIComponent(
      phoneNumber
    )}&otpType=${requestType}&patientDocumentId=${profileId}&otp=${otp}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "x-auth-token": `Bearer ${fireBaseAccessToken}`
      }
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function searchABHANumber(fireBaseAccessToken, data) {
  const response = await fetch(
    `${api.baseUrl}/abhaAddressAuthentication/search/abhaNumber`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function generateOtpForAbdmAuth(fireBaseAccessToken, auth, data) {
  const response = await fetch(
    `${api.baseUrl}/abhaAddressAuthentication/${auth}/generateOtp`,
    {
      method: "POST",
      headers: getHeaders({
        fireBaseAccessToken
      }),
      body: JSON.stringify(data)
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function verifyOtpForAbdmAuth(fireBaseAccessToken, auth, data) {
  const response = await fetch(
    `${api.baseUrl}/abhaAddressAuthentication/${auth}/verifyOtp`,
    {
      method: "POST",
      headers: getHeaders({ fireBaseAccessToken }),
      body: JSON.stringify(data)
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function getModesForAbdmAuth(fireBaseAccessToken, auth, value) {
  const response = await fetch(
    `${
      api.baseUrl
    }/abhaAddressAuthentication/${auth}/authModes?value=${encodeURIComponent(
      value
    )}`,
    {
      method: "GET",
      headers: getHeaders({
        fireBaseAccessToken
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  } else {
    return result;
  }
}

export async function confirmLoginForAbdmAuth(fireBaseAccessToken, data) {
  const response = await fetch(
    `${api.baseUrl}/abhaAddressAuthentication/login/confirm`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": `Bearer ${fireBaseAccessToken}`
      }
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function createHealthId(fireBaseAccessToken, data) {
  const response = await fetch(
    `${api.baseUrl}/abhaAddressAuthentication/register/confirm`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": `Bearer ${fireBaseAccessToken}`
      },
      body: JSON.stringify({
        ...data
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function getCareContexts(
  abdmAccessToken,
  fireBaseAccessToken,
  profileId
) {
  const response = await fetch(
    `${api.baseUrl}/abdmCareContext/getPatientCareContextList`,
    {
      method: "GET",
      headers: getHeaders({ abdmAccessToken, fireBaseAccessToken, profileId })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function getConsentArtefact(
  abdmAccessToken,
  fireBaseAccessToken,
  profileId
) {
  const response = await fetch(
    `${api.baseUrl}/consentManager/getConsentArtefacts`,
    {
      method: "GET",
      headers: getHeaders({ abdmAccessToken, fireBaseAccessToken, profileId })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function denyRequests(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data,
  type
) {
  const response = await fetch(`${api.baseUrl}/consentManager/${type}/deny`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: getHeaders({
      fireBaseAccessToken,
      abdmAccessToken,
      profileId
    })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function editSubscriptionRequest(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/consentManager/subscription/edit`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function searchAbdmClinics(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  searchString
) {
  const response = await fetch(
    `${api.baseUrl}/abdmCareContext/searchProviderDetails?name=${searchString}`,
    {
      method: "GET",
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );

  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function searchAbdmClinicsWithHipId(
  abdmAccessToken,
  fireBaseAccessToken,
  profileId,
  searchString
) {
  const response = await fetch(
    `${api.baseUrl}/abdmCareContext/getProviderDetailsById?hipId=${searchString}`,
    {
      method: "GET",
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );

  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function getPublicHealthPrograms(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId
) {
  const response = await fetch(`${api.baseUrl}/abdmCareContext/govtPrograms`, {
    method: "GET",
    headers: getHeaders({
      fireBaseAccessToken,
      abdmAccessToken,
      profileId
    })
  });

  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function discoverCareContextUsingClinicId(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(`${api.baseUrl}/abdmCareContext/discover`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: getHeaders({
      fireBaseAccessToken,
      abdmAccessToken,
      profileId
    })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function linkAbdmCareContextSendOtp(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(`${api.baseUrl}/abdmCareContext/linkRequest`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: getHeaders({
      fireBaseAccessToken,
      abdmAccessToken,
      profileId
    })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function linkAbdmCareContextConfirmOtp(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(`${api.baseUrl}/abdmCareContext/linkConfirm`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: getHeaders({
      fireBaseAccessToken,
      abdmAccessToken,
      profileId
    })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function shareProfile(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(`${api.baseUrl}/profile/share`, {
    method: "POST",
    headers: getHeaders({ fireBaseAccessToken, abdmAccessToken, profileId }),
    body: JSON.stringify(data)
  });

  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function acceptAndShareConnectionToClinic(
  abdmLoginAccessToken,
  hipId,
  hipCode
) {
  const headersList = {
    "abdm-login-token": abdmLoginAccessToken,
    "Content-Type": "application/json"
  };

  const bodyContent = JSON.stringify({
    hipId,
    hipCode
  });

  const response = await fetch(`${api.baseUrl}/profile/share`, {
    method: "POST",
    headers: headersList,
    body: bodyContent
  });

  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function acceptAutoApprove(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/consentManager/auto-approval-policy/enable`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function createAutoApprovalPolicy(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/consentManager/auto-approval-policy`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function getPatientTokenHistory(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId
) {
  const response = await fetch(`${api.baseUrl}/profile/tokenHistory`, {
    method: "GET",
    headers: getHeaders({ fireBaseAccessToken, abdmAccessToken, profileId })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    } else {
      throw result.error;
    }
  }
  return result;
}

export async function getPatientQrDetails(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId
) {
  const response = await fetch(`${api.baseUrl}/profile/getMyQrCode`, {
    method: "GET",
    headers: getHeaders({ fireBaseAccessToken, abdmAccessToken, profileId })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    } else {
      throw result.error;
    }
  }
  return result;
}

export async function getPatientCardDetails(
  fireBaseAccessToken,
  abdmAccessToken,
  abhaAccessToken,
  profileId,
  type
) {
  const response = await fetch(
    `${api.baseUrl}/${
      type === "ABHA Address"
        ? "abhaAddressAuthentication"
        : "abhaNumberAuthentication"
    }/profile/card`,
    {
      method: "GET",
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        ...(type === "ABHA Address"
          ? {}
          : {
              abhaAccessToken
            }),
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    } else {
      throw result.error;
    }
  }
  return result;
}

export async function generateOTPForUpdatePhoneNumberOrEmail(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/profile/update/mobileEmail/sendOtp`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function verifyOTPForUpdatePhoneNumberOrEmail(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/profile/update/mobileEmail/verifyOtp`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({ abdmAccessToken, fireBaseAccessToken, profileId })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function abhaAddressResetPassword(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(`${api.baseUrl}/profile/resetPassword`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: getHeaders({
      fireBaseAccessToken,
      abdmAccessToken,
      profileId
    })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function lockerAuthorizationRequest(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId
) {
  const response = await fetch(`${api.baseUrl}/consentManager/locker/setup`, {
    method: "POST",
    body: JSON.stringify({
      lockerId: lockerSetup.locker
    }),
    headers: getHeaders({
      fireBaseAccessToken,
      abdmAccessToken,
      profileId
    })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function getPatientRequests(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId
) {
  const response = await fetch(
    `${api.baseUrl}/consentManager/getPatientRequests`,
    {
      method: "GET",
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function retryDataTransfer(
  fireBaseAccessToken,
  abdmAccessToken,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/consentManager/healthInformation/request`,
    {
      method: "POST",
      headers: getHeaders({ abdmAccessToken, fireBaseAccessToken }),
      body: JSON.stringify(data)
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function uploadDocument(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(`${api.baseUrl}/uploadDocument/upload`, {
    method: "POST",
    headers: getHeaders({
      abdmAccessToken,
      fireBaseAccessToken,
      profileId,
      removeContentType: true
    }),
    body: data
  });

  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function disableAutoApprovalPolicy(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/consentManager/auto-approval-policy/disable`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function getHealthIdData(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId
) {
  const response = await fetch(`${api.baseUrl}/profile`, {
    method: "GET",
    headers: getHeaders({ fireBaseAccessToken, abdmAccessToken, profileId })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function editHealthIdData(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(`${api.baseUrl}/profile/edit`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: getHeaders({
      fireBaseAccessToken,
      abdmAccessToken,
      profileId
    })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function linkAbhaNumber(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data,
  type
) {
  const response = await fetch(
    `${api.baseUrl}/profile/link/abhaNumber/${type}`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({ abdmAccessToken, fireBaseAccessToken, profileId })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function deLinkAbhaNumber(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data,
  type
) {
  const response = await fetch(
    `${api.baseUrl}/profile/delink/abhaNumber/${type}`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({ abdmAccessToken, fireBaseAccessToken, profileId })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function generateOtpForUnlinkAbhaAddressFromAbhaNumber(
  fireBaseAccessToken,
  abdmAccessToken,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/abhaNumberAuthentication/login/init`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({ abdmAccessToken, fireBaseAccessToken })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function confirmUnlinkAbhaAddressFromAbhaNumber(
  fireBaseAccessToken,
  abdmAccessToken,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/abhaNumberAuthentication/login/confirm`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({ abdmAccessToken, fireBaseAccessToken })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function linkOrUnlinkAbhaAddressFromAbhaNumber(
  fireBaseAccessToken,
  abdmAccessToken,
  data,
  type
) {
  const response = await fetch(
    `${api.baseUrl}/abhaNumberAuthentication/abhaAddress/${type}`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({ abdmAccessToken, fireBaseAccessToken })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function createAbhaNumber(
  fireBaseAccessToken,
  profileId,
  data,
  authMode,
  type
) {
  const response = await fetch(
    `${api.baseUrl}/abhaNumberAuthentication/register/${authMode}/${type}`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function generateLinkingToken(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/consentManager/generate/linkingToken`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function acceptRequest(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data,
  type
) {
  const response = await fetch(`${api.baseUrl}/consentManager/${type}/accept`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: getHeaders({
      fireBaseAccessToken,
      abdmAccessToken,
      profileId
    })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function revokeRequest(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data,
  type
) {
  const response = await fetch(`${api.baseUrl}/consentManager/${type}/revoke`, {
    method: "POST",
    body: JSON.stringify({
      ...data
    }),
    headers: getHeaders({
      fireBaseAccessToken,
      abdmAccessToken,
      profileId
    })
  });
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function switchProfile(fireBaseAccessToken, profileId, data) {
  const response = await fetch(
    `${api.baseUrl}/abhaAddressAuthentication/switch-profile`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }

  return result;
}

export async function suggestABHAAddress(fireBaseAccessToken, data) {
  const response = await fetch(
    `${api.baseUrl}/abhaAddressAuthentication/register/suggestion`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function suggestABHAAddressFromABHANumberCreation(
  fireBaseAccessToken,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/abhaNumberAuthentication/register/abhaAddress/suggest`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function refreshABDMToken(fireBaseAccessToken, data) {
  const response = await fetch(
    `${api.baseUrl}/abhaAddressAuthentication/getAbdmAccessToken`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: getHeaders({
        fireBaseAccessToken
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function getUpdatedRequest(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const key = data.type === "subscription" ? "subscription" : "consentRequest";
  const response = await fetch(
    `${api.baseUrl}/consentManager/${data.type}/request?${key}Id=${data.id}`,
    {
      method: "GET",
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function getUpdatedConsentArtefactRequest(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/consentManager/consentArtefact/request?consentRequestId=${data.id}`,
    {
      method: "GET",
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      })
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}

export async function ABHANumberCreateABHAAddress(
  fireBaseAccessToken,
  abdmAccessToken,
  profileId,
  data
) {
  const response = await fetch(
    `${api.baseUrl}/abhaNumberAuthentication/register/abhaAddress/confirm`,
    {
      method: "POST",
      headers: getHeaders({
        fireBaseAccessToken,
        abdmAccessToken,
        profileId
      }),
      body: JSON.stringify(data)
    }
  );
  const result = await response.json();
  if (result.error) {
    if (result.error.name === "requestError") {
      throwError("custom", result.error.message);
    }
    if (result.error.name === "authError") {
      throwError("auth", "Token Expired");
    }
    throw result.error;
  }
  return result;
}
